import gsap from 'gsap'
import Site from 'stores/Site'

export default class Header {
    constructor(el) {
        this.el = el
        this.scroll = {
            current: 0,
            last: 0,
            direction: 1
        }

        this.initDesktopMenu()
        this.initCallBtn()
    }

    initCallBtn() {
        if (!(Site.html.classList.contains('is-global') && Site.body.classList.contains('page-template-template-contact-php'))) return

        const btn = this.el.querySelector('.header-cta-btn')
        const section = Site.page.querySelector('.contact')

        btn.addEventListener('click', (e) => {
            e.preventDefault()

            const headerHeight = this.el.offsetHeight
            const targetPosition = section.getBoundingClientRect().top + window.scrollY
            const offsetPosition = targetPosition - headerHeight

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        })
    }

    initDesktopMenu() {
        const menu = this.el.querySelector('.header-nav .menu')
        const parentLinks = menu.querySelectorAll('.menu-item-depth-0 .menu-item-has-children a')
        const columns = menu.querySelectorAll('.columns')
        let menuActive = false

        columns.forEach(column => {
            const items = Array.from(column.querySelectorAll('.menu-item-depth-2'))
            const submenu = column.querySelector('.sub-menu')

            if (items.length === 0) return

            const column1 = document.createElement('div')
            column1.classList.add('menu-item-column')

            const column2 = document.createElement('div')
            column2.classList.add('menu-item-column')

            const half = Math.ceil(items.length / 2)

            items.slice(0, half).forEach(item => column1.appendChild(item))
            items.slice(half).forEach(item => column2.appendChild(item))

            submenu.innerHTML = ""
            submenu.appendChild(column1)
            submenu.appendChild(column2)
        })

        menu.addEventListener('mouseenter', () => {
            menuActive = true
        })

        menu.addEventListener('mouseleave', () => {
            menuActive = false

            parentLinks.forEach(link => {
                const parent = link.parentNode

                if (parent.classList.contains('menu-item-active')) {
                    parent.classList.remove('menu-item-active')
                }
            })
        })

        parentLinks.forEach(link => {
            const parent = link.parentNode

            link.addEventListener('click', (e) => {
                if (e.target.classList.contains('toggle')) {
                    e.preventDefault()

                    if (parent.classList.contains('menu-item-active')) {
                        parent.classList.remove('menu-item-active')
                    } else {
                        parent.classList.add('menu-item-active')
                    }
                }
            })
        })
    }

    onResize() {
        if (Site.html.classList.contains('nav-active')) {
            Site.html.classList.remove('nav-active')
        }
    }

    onScroll(e) {
        this.scroll.current = window.scrollY || document.documentElement.scrollTop

        if (this.scroll.current > this.scroll.last) {
            this.scroll.direction = 1
        } else {
            this.scroll.direction = -1
        }

        this.scroll.last = this.scroll.current <= 0 ? 0 : this.scroll.current

        if (this.scroll.current > 0) {
            Site.html.classList.add('scrolled')
        } else {
            Site.html.classList.remove('scrolled')
        }

        if (this.scroll.current > 100) {
            Site.html.classList.add('header-scrolled')
        } else {
            Site.html.classList.remove('header-scrolled')
        }

        if (Site.html.classList.contains('scrolled')) {
            if (this.scroll.direction === -1) {
                Site.html.classList.remove('scrolled-down')
                Site.html.classList.add('scrolled-up')
            } else if (this.scroll.direction === 1) {
                Site.html.classList.remove('scrolled-up')
                Site.html.classList.add('scrolled-down')
            }
        } else {
            Site.html.classList.remove('scrolled-up')
            Site.html.classList.remove('scrolled-down')
        }
    }
}